{
  "collapse": "Daralt",
  "expand": "Genişlet"
}
